import React, { useState, useEffect } from 'react';
import { awards } from '../data/mockData';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % awards.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const nextAward = () => {
    setCurrentIndex((prev) => (prev + 1) % awards.length);
  };

  const prevAward = () => {
    setCurrentIndex((prev) => (prev - 1 + awards.length) % awards.length);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our Testimonials
          </h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto"></div>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="relative h-96 md:h-[500px] overflow-hidden rounded-lg shadow-2xl">
            {awards.map((award, index) => (
              <div
                key={award.id}
                className={`absolute inset-0 transition-all duration-700 ${
                  index === currentIndex
                    ? 'opacity-100 scale-100'
                    : 'opacity-0 scale-95'
                }`}
              >
                <img
                  src={award.image}
                  alt={award.title}
                  className="w-full h-full object-contain bg-white p-8"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-8">
                  <h3 className="text-white text-2xl font-bold text-center">
                    {award.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevAward}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white hover:bg-orange-600 text-gray-800 hover:text-white p-3 rounded-full shadow-lg transition-all duration-200 z-10"
          >
            <ChevronLeft size={24} />
          </button>
          <button
            onClick={nextAward}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white hover:bg-orange-600 text-gray-800 hover:text-white p-3 rounded-full shadow-lg transition-all duration-200 z-10"
          >
            <ChevronRight size={24} />
          </button>

          {/* Indicators */}
          <div className="flex justify-center mt-8 space-x-3">
            {awards.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? 'bg-orange-600 w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg">
            View All Awards
          </Button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;